<template>
  <li class="swipe-card">
    <Image :source="content.image" class="--promotion" />
    <h3 class="heading --card swipe-card__content">{{ content.title }}</h3>
    <RawHtml :html="content.description" class="swipe-card__content" />
  </li>
</template>

<script>
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import HasContentProp from '@/mixins/HasContentProp'

export default {
  name: 'PromotionCard',
  mixins: [HasContentProp],
  components: {
    Image,
    RawHtml,
  },
}
</script>
